module.exports = __webpack_public_path__ + "static/media/galdisa_acerca_de_sustentabilidad.a210f5ee.jpg";